import { useCallback, useRef } from 'react'
import useClickOutside from '../../hooks/use-clickoutside'

export default function ClickOutsideBoundary({
  disabled = false,
  name,
  onClose,
  children,
  mouseDownTarget,
  ...rest
}) {
  const nodeRef = useRef()

  const handleClose = useCallback(() => {
    onClose(name)
  }, [name, onClose])

  useClickOutside(nodeRef, handleClose, disabled, mouseDownTarget)

  return (
    <div ref={nodeRef} {...rest}>
      {children}
    </div>
  )
}
